import { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { debounce } from "lodash";
import { UserContext } from "../../../../Context/UserContext";
export const GatePassTypeSelectGPUpdDirect = ({
  selectedOption,
  setSelectedOption,
  setCacheTypeFun,

  setParty,
  setGatePassInType,
  setGatePassOutType,
  setPartyDetail,
  setGpRgp,
  setGpNrgp,
}) => {
  const { darkTheme, loginData, indentUpdateData } = useContext(UserContext);
  const [options, setOptions] = useState([
    { value: "IN", label: "IN" },
    { value: "OUT", label: "OUT" },
  ]);
  // const [inputValue, setInputValue] = useState('');

  // useEffect(() => {
  //   function loadDefaultSeverity() {
  //     if (selectedOption === "Normal") {
  //       const myFilter = options.filter(
  //         (item) => item.value === selectedOption
  //       );
  //       // const transformedOptions = myFilter.map((item) => ({
  //       //   value: item.value,
  //       //   label: item.value,
  //       // }));
  //       const myFind = myFilter.find((item) => item.value === selectedOption);
  //       postCacheItem(myFind.label);
  //       return setSelectedOption(myFind);
  //     }
  //   }
  //   loadDefaultSeverity();
  // }, []);

  // function getUpdSeverity() {
  //   if (selectedOption !== "") {
  //     const myFilter = options.filter((item) => item.value === selectedOption);
  //     // const transformedOptions = myFilter.map((item) => ({
  //     //   value: item.value,
  //     //   label: item.value,
  //     // }));
  //     const myFind = myFilter.find((item) => item.value === selectedOption);
  //     setSelectedOption(myFind);
  //   }
  // }
  // useEffect(() => {
  //   getUpdSeverity();
  // }, [indentUpdateData]);

  // Handle option select
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setCacheTypeFun(selectedOption);
    // if(selectedOption?.label){
    // }
    setParty("");
    setGatePassInType("");
    setGatePassOutType("");
    setPartyDetail("");
    setGpRgp("");
    setGpNrgp("");
  };

  // Custom styling
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "white" : "black"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black",
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  return (
    <Select
      // onBlur={postCacheItem}
      styles={customStyles}
      options={options}
      // onInputChange={handleInputChange}
      // inputValue={inputValue}
      onChange={handleChange}
      value={selectedOption}
      placeholder="Select"
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
    />
  );
};
